import qs from 'qs';

import { toBoolean } from '~/renderer/utils/to-boolean';
import { BarcodeParams } from '~/renderer/utils/transform-html/types';

const assertIsBarcode = (arg: { [key: string]: unknown } | BarcodeParams): arg is BarcodeParams =>
  typeof arg.number === 'string';

export const extractBarcodeParams = (srcAttribute: string): BarcodeParams => {
  const parsedParams =
    qs.parse(srcAttribute.replace(/.+\?/, ''), {
      ignoreQueryPrefix: true,
      decoder: (value: string | boolean) => {
        if (typeof value === 'string') {
          if (!value || ['true', 'false', '0', '1'].includes(value)) {
            return toBoolean(value);
          }
          return value.replace(/^amp;/, '');
        }

        return value;
      },
    }) || {};

  if (parsedParams.ean8) {
    parsedParams.encoding = 'ean8';
    delete parsedParams.ean8;
  }

  if (!assertIsBarcode(parsedParams)) {
    throw new Error('Image source is missing barcode params');
  }

  return parsedParams;
};
